import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfUse from "./components/TermsOfUse";
import CookiePolicy from "./components/CookiePolicy";
import TermsAndPolicy from "./components/TermsAndPolicy";

const AllTerms = () => {
    const [searchParams] = useSearchParams();
    const defaultTab = searchParams.get("tab") || "PrivacyPolicy";
    const [activeTab, setActiveTab] = useState(defaultTab);

    const tabs = [
        { name: "PrivacyPolicy", label: "Privacy Policy", component: <PrivacyPolicy /> },
        { name: "TermsOfUse", label: "Terms of Use", component: <TermsOfUse /> },
        { name: "CookiePolicy", label: "Cookie Policy", component: <CookiePolicy /> },
        { name: "TermsAndConditions", label: "Terms and Conditions", component: <TermsAndPolicy /> },
    ];

    useEffect(() => {
        const tabFromURL = searchParams.get("tab");
        if (tabFromURL && tabFromURL !== activeTab) {
            setActiveTab(tabFromURL);
        }
    }, [searchParams]);

    return (
        <div className="min-h-screen bg-gray-50 p-10">
            <div className="max-w-4xl mx-auto bg-white shadow-md rounded-lg">
                <div className="border-b border-gray-200">
                    <nav className="flex space-x-4 p-4">
                        {tabs.map((tab, index) => (
                            <button
                                key={index}
                                className={`px-4 py-2 font-semibold text-sm rounded-lg transition-colors ${activeTab === tab.name
                                    ? "bg-blue-500 text-white"
                                    : "bg-gray-200 text-gray-700 hover:bg-blue-100"
                                    }`}
                                onClick={() => setActiveTab(tab.name)}
                            >
                                {tab.label}
                            </button>
                        ))}
                    </nav>
                </div>
                <div className="p-6">
                    {tabs.find((tab) => tab.name === activeTab)?.component}
                </div>
            </div>
        </div>
    );
};

export default AllTerms;
